import { render, staticRenderFns } from "./headFeeNewDialog.vue?vue&type=template&id=3b0e2dd6&lang=true"
import script from "./headFeeNewDialog.vue?vue&type=script&lang=js"
export * from "./headFeeNewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports